import React from "react";
import { Dropdown } from "antd";
import { Button, Link } from "../styles/Design";
import { withNamespaces } from "react-i18next";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import DropDownMenu from "./DropDownMenu";
import { useMediaQuery } from "react-responsive";

const UserTools = ({ t }) => {
  const navigate = useNavigate();
  const user = localStorage.getItem("user");
  const isLoggedIn = user ? true : false;
  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/");
  };
  const UserToolsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 15%;
    @media (max-width: 768px) {
      margin-top: 1rem;
      width: 100%;
      flex-direction: column;
    }
  `;
  const AuthContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 90%;

    @media (max-width: 768px) {
      margin-top: 2rem;
      width: 100%;
    }
  `;
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <>
      <UserToolsContainer>
        {isLoggedIn ? (
          <Dropdown
            overlay={<DropDownMenu logoutCallback={handleLogout} />}
            trigger={["click"]}
          >
            <Link
              to="/"
              className="ant-dropdown-link"
              onClick={(e) => e.preventDefault()}
            >
              <UserOutlined style={{ fontSize: "20px", color: "#fff" }} />
            </Link>
          </Dropdown>
        ) : (
          <>
            <AuthContainer>
              <Link type={isMobile ? "primary" : "secondary"} to="/auth/login">
                {t("pages.auth.login")}
              </Link>
              <Button
                type={isMobile ? "primary" : "secondary"}
                onClick={() => navigate("/auth/register")}
              >
                {t("pages.auth.register")}
              </Button>
            </AuthContainer>
          </>
        )}
      </UserToolsContainer>
    </>
  );
};

export default withNamespaces()(UserTools);
